


































import { Component, Vue, Prop } from 'vue-property-decorator'
import Content from '@/store/models/content'
import MovieIcon from 'vue-material-design-icons/Play.vue'
import FileIcon from 'vue-material-design-icons/File.vue'
import StarIcon from 'vue-material-design-icons/Star.vue'
import StarHalfIcon from 'vue-material-design-icons/StarHalfFull.vue'
import StarOutlineIcon from 'vue-material-design-icons/StarOutline.vue'
import { Action } from 'vuex-class'
import * as types from '@/store/content/types'
import { AxiosResponse } from 'axios'

@Component({ components: { FileIcon, MovieIcon, StarIcon, StarHalfIcon, StarOutlineIcon } })
export default class VContentBox extends Vue {
  @Prop() item!: Content
  @Action('youtubeDetails', { namespace: 'content' }) youtubeDetails!: types.YoutubeDetailsAction

  private hover = false
  private duration = null

  private created () {
    if (this.item.content_format === 'VIDEO') {
      this.youtubeDetails(this.item.url.split(/[=&]+/)[1]).then((response: AxiosResponse) => {
        if (response.data.items.length > 0) {
          this.duration = response.data.items[0].contentDetails.duration.split(/[A-Z]/)
            .filter((val: string) => val !== '')
            .reduce((acc: string, val: string) => acc + ':' + (val.length === 1 ? 0 + val : val))
        }
      })
    }
  }

  private goToCinema () {
    const params: { [key: string]: string } = { contentId: this.item.user_id.toString() }
    if (this.item.bookId !== undefined) {
      params.id = this.item.bookId.toString()
    }
    if (this.item.categoryId !== undefined) {
      params.category = this.item.categoryId.toString()
    }
    this.$router.push({ name: 'cinema', params })
  }

  private get thumbLink () {
    if (this.item.user_id === -1) { // If content is not loaded
      return ''
    }
    return 'https://img.youtube.com/vi/' + this.item.url.split(/[=&]+/)[1] + '/0.jpg'
  }
}
